'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import text from 'I18n/utils/unescapedText';
import * as FilesActions from 'DesignData/actions/finder/Files';
import * as FinderAssetActions from 'DesignData/actions/finder/Assets';
import * as finderSelectors from 'DesignData/selectors/finder';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import FileResults from 'DesignFinderUI/components/results/FileResults';

const i18nKey = key => `DesignFinderUI.results.RecentlyDeletedFiles.${key}`;

function mapStateToProps(state) {
  return {
    fetchError: finderSelectors.getRecentlyDeletedFetchError(state),
    isFetching: finderSelectors.getIsFetchingRecentlyDeleted(state),
    results: finderSelectors.getRecentlyDeletedFiles(state)
  };
}

const mapDispatchToProps = {
  fetchRecentlyDeleted: FinderAssetActions.fetchRecentlyDeleted,
  restoreDeleted: FilesActions.restoreDeleted,
  closeFinderRecentlyDeleted: FinderAssetActions.closeRecentlyDeleted
};

class RecentlyDeletedFiles extends Component {
  constructor(...args) {
    super(...args);

    this.handleRestoreFile = fileId => {
      this.props.restoreDeleted(fileId);
    };
  }

  componentDidMount() {
    this.props.fetchRecentlyDeleted();
  }

  render() {
    const {
      isFetching,
      results
    } = this.props;
    return isFetching ? /*#__PURE__*/_jsx(UILoadingSpinner, {
      layout: "centered",
      grow: true
    }) : /*#__PURE__*/_jsx(FileResults, Object.assign({}, this.props, {
      asLinks: false,
      total: results.length,
      emptyText: {
        header: text(i18nKey('results.empty.header')),
        help: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: i18nKey('results.empty.help')
        })
      },
      headerText: text(i18nKey('header')),
      itemProps: {
        buttonText: text(i18nKey('results.button.text')),
        onButtonClick: this.handleRestoreFile
      },
      onClose: this.props.closeFinderRecentlyDeleted
    }));
  }

}

RecentlyDeletedFiles.propTypes = Object.assign({}, FileResults.propTypes, {
  fetchRecentlyDeleted: PropTypes.func.isRequired,
  restoreDeleted: PropTypes.func.isRequired
});
RecentlyDeletedFiles.defaultProps = Object.assign({}, FileResults.defaultProps);
export default connect(mapStateToProps, mapDispatchToProps)(RecentlyDeletedFiles);